import { useToggle } from '@hooks/useToggle';
import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Avatar, Button, Grid, lighten, makeStyles, Typography } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SearchIcon from '@material-ui/icons/Search';
import { useThemeColor } from '@themes/Colors';
import clsx from 'clsx';
import React from 'react';
import { PrimaryButton } from '@components/Buttons/PrimaryButton';

export type FixedFilterPanelProps = React.PropsWithChildren<{
    onSearch: VoidFunction,
    onClear: VoidFunction,
    disabled?: boolean
    startExpanded?: boolean
}>

export function FixedFilterPanel({ 
    disabled, 
    children,
    onSearch,
    onClear,
    startExpanded
}: FixedFilterPanelProps) {
    const expanded = useToggle(startExpanded !== false);

    const cls = useStyles();
    const themeColor = useThemeColor()
    
    return (
        <Accordion elevation={5} disabled={disabled} className={cls.accordion} expanded={expanded.value} onChange={expanded.handleTick}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={cls.accordionSummary}>
                <Grid container alignItems='center' spacing={1}>
                    <Grid item>
                        <Avatar className={cls.avatar}>
                            <SearchIcon fontSize="small" />                    
                        </Avatar>
                    </Grid>
                    <Grid item>
                        <Typography variant='subtitle2'><b>Painel de Pesquisa</b></Typography>
                    </Grid>

                </Grid>
            </AccordionSummary>

            <AccordionDetails className={cls.accordionDetails}>
            { children }
            </AccordionDetails>

            <AccordionActions className={clsx(themeColor.component.commandPanel, cls.accordionActions)}>
                <Button onClick={onClear} disabled={disabled} startIcon={<ClearIcon />}>Limpar</Button>
                <PrimaryButton startIcon={<SearchIcon />} onClick={onSearch} disabled={disabled}>Pesquisar</PrimaryButton>
            </AccordionActions>
        </Accordion>
    );
}

const useStyles = makeStyles(theme => ({
    accordion: {
        '&:before': {
            height: 0
        },

        '&.Mui-expanded': {
            margin: 0
        },

        marginBottom: `${theme.spacing(3)}px !important`
    },

    accordionSummary: {
        padding: `0 ${theme.spacing(1)}px`,
        backgroundColor: lighten(theme.palette.primary.light, 0.9),
        '&.Mui-expanded': { 
            minHeight: 0,
            borderBottom: '1px solid rgba(0, 0, 0, .125)'
        },
        '& div.MuiAccordionSummary-content.Mui-expanded': {
            margin: '0'
        },
    },

    accordionDetails: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3)
    },

    accordionActions: {
        //borderWidth: '0px 1px 0 1px',
        //borderStyle: 'solid',
        //borderColor: 'rgba(0, 0, 0, .125)',
        justifyContent: 'flex-start',
    },

    avatar: {
        width: theme.spacing(3),
        height: theme.spacing(3),
    }
}));